import Header from './components/Header';
import Home from './views/HomeView';
import ComoFunciona from './views/ComoFuncionaView';
import Contato from './views/Contato';
import NossosDiferenciais from './views/NossosDiferenciais';
import QuemSomos from './views/QuemSomos';
import Sobre from './views/SobreView';
import PrivacyPolicy from './views/PoliticaPrivacidade';
import TermsOfUse from './views/TermosUso';
import { Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div style={{ overflowX: 'hidden', width: '100%' }}>
      <Header />
      <main style={{ width: '100%' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/como-funciona" element={<ComoFunciona />} />
          <Route path="/nossosdiferenciais" element={<NossosDiferenciais />} />
          <Route path="/quemsomos" element={<QuemSomos />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
          <Route path="/termos-de-uso" element={<TermsOfUse />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
